export default __webpack_public_path__ + "static/media/2.4f8bc335.svg";